import { ReactElement, RefObject } from 'react'
import { FA_TIMES } from 'const/icons'
import i18n from 'lang/i18n'
import {
  CloseIcon,
  ContainerHeader,
  HeaderText,
  ModalClose
} from './subcomponents'

export interface ModalHeaderProps {
  headerRef?: RefObject<HTMLHeadingElement>
  headerText: ReactElement | string
  primaryColor?: string
  secondaryColor?: string
  closeButton?: () => void
}

const ModalHeader = ({
  headerRef,
  headerText,
  primaryColor,
  secondaryColor,
  closeButton
}: ModalHeaderProps): ReactElement => {
  return (
    <ContainerHeader primary={primaryColor} className="modalHeader">
      <HeaderText
        ref={headerRef}
        secondary={secondaryColor}
        tabindex="-1"
        weight="bold"
      >
        {headerText}
      </HeaderText>
      <ModalClose
        aria-label={i18n({ modalContent: 'closeModal' }) as string}
        onClick={closeButton}
        name="close"
      >
        <CloseIcon name={FA_TIMES} secondary={secondaryColor} />
      </ModalClose>
    </ContainerHeader>
  )
}

export default ModalHeader
